if (!customElements.get('b2b-brand-marquee')) {
  customElements.define('b2b-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-brand-row]'));
      this.button = this.querySelector('[data-brand-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.onToggle = () => {
        this.paused = !this.paused;
        this.toggleAttribute('data-paused', this.paused);
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
      };
      this.onMotion = () => this.rebuild();
      this.onBlockSelect = event => {
        if (!this.contains(event.target)) return;
        this.setAttribute('data-editing', '');
        this.rebuild();
        event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
      };
      this.onBlockDeselect = () => {
        this.removeAttribute('data-editing');
        this.rebuild();
      };
      this.button.addEventListener('click', this.onToggle);
      this.motion.addEventListener('change', this.onMotion);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.getBoundingClientRect().width;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        this.rebuild();
      });
      this.resizeObserver.observe(this);
      this.rebuild();
    }

    duplicate(node) {
      const copy = node.cloneNode(true);
      copy.setAttribute('data-brand-copy', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id');
        element.removeAttribute('data-shopify-editor-block');
      });
      return copy;
    }

    rebuild() {
      const animate = this.rows.length > 0 && this.dataset.autoplay === 'true' && !this.motion.matches && !this.hasAttribute('data-editing');
      this.removeAttribute('data-running');
      this.querySelectorAll('[data-brand-copy]').forEach(copy => copy.remove());
      this.rows.forEach(row => {
        row.scrollLeft = 0;
        if (!animate) return;
        const track = row.querySelector('[data-brand-track]');
        const group = row.querySelector('[data-brand-group]');
        const originals = Array.from(group.children);
        const width = group.getBoundingClientRect().width;
        if (!originals.length || !width) return;
        // Each identical half must cover the viewport, even with a single card.
        const repeats = Math.max(1, Math.ceil(row.clientWidth / width));
        // Offset the second row by half a card and gap, regardless of card count.
        track.style.setProperty('--brand-half-card-phase', String(-0.5 / (originals.length * repeats)));
        for (let repeat = 1; repeat < repeats; repeat++) {
          originals.forEach(card => group.appendChild(this.duplicate(card)));
        }
        track.appendChild(this.duplicate(group));
      });
      this.toggleAttribute('data-running', animate);
      this.button.hidden = !animate;
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
      this.motion?.removeEventListener('change', this.onMotion);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }
  });
}
